<template>
  <div id="app" data-app>
    <transition name="fade" appear>
      <div class="modal-overlay" v-if="modal" @click="dismissModal"></div>
    </transition>
    <transition name="slide" appear>
      <div class="modal" v-if="modal">
        <h1 class="nunitoBold">Smart Tales</h1>
        <p class="ralewayRegular">
          {{ modalText }}
        </p>
        <button class="button" @click="dismissModal">
          Close
        </button>
      </div>
    </transition>
    <loading
      :active.sync="loadingState"
      :color="color"
      :width="loaderSize"
      :height="loaderSize"
      :loader="loaderStyle"
      :is-full-page="true"
    >
    </loading>
    <vue-confirm-dialog></vue-confirm-dialog>
    <div class="bodyContainer">
      <header class="headerContainer site-nav">
        <div class=" headerGrid">
          <div class="logoContainer">
            <img
              src="@/assets/images/home/smart_tales_logo_basic.png"
              alt="smart-tales"
              class="imgSmartTales"
            />
          </div>

          <span
            class="menuText ralewayBold"
            @click="topMenuClick()"
            v-if="this.$route.name != 'Checkout'"
          >
            {{ topMenuLabel }}
          </span>
          <v-select
            :items="languages"
            class="dropLanguage"
            v-model="selectedLang"
            @input="selectLang"
            :clearable="false"
            v-if="this.$route.name != 'Checkout'"
          >
            <template v-slot:item="{ item }">
              <div class="dropdownImgOptionsContainer">
                <div class="dropLanguageCodeContainer">
                  <span class="ralewayRegular dropLanguageCode">{{
                    item.title.toUpperCase()
                  }}</span>
                </div>
                <img class="dropdownImg" :src="getImageLangUrl(item)" />
              </div>
            </template>
            <template v-slot:selection="{ item }">
              <img class="dropdownImgSelected" :src="getImageLangUrl(item)" />
            </template>
          </v-select>
        </div>
      </header>

      <div class="routerContainer">
        <router-view />
        <div class="footerContainer mb-8">
          <h2 class="footerLine" />
          <div class="footerLeftBox">
            <img
              src="@/assets/images/home/smart_tales_logo_basic.png"
              alt="smart-tales"
              class="imgSmartTales"
            />
          </div>
          <div class="footerRightBox">
            <p class="footerSmartTalesTitle ralewayBold">
              <a href="https://smarttales.app" target="_blank">Website</a>
            </p>
            <p class="footerSmartTalesContact ralewayBold">
              <a
                href="mailto:support@smarttales.app"
                v-on:click="clickedContactUs"
              >
                {{ $t('k_footer_contact_us') }}</a
              >
            </p>
          </div>
          <div class="footerReserved ralewayBold">
            2023 Marshmallow Games SRL - All Rights Reserved.
            <p class="footerReservedHeart">♥</p>
          </div>
          <div class="versionText"></div>
        </div>
      </div>
      <cookie-law
        :buttonDecline="showDecline"
        v-on:decline="handleChoiceCookie"
      >
      </cookie-law>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { version } from '../package.json'
import { topMenuLink } from './services/currentTopLink'
import { localeChanged } from 'vee-validate'
import { trackEvent } from './plugins/analyticsTracker'
import CookieLaw from 'vue-cookie-law'

// @ is an alias to /src
export default {
  name: 'App',
  components: {
    Loading,
    CookieLaw
  },
  data: function() {
    return {
      showDecline: true,
      isAuthenticated: false,
      isMobile: false,
      color: '#f7a036',
      loaderSize: 50,
      loaderStyle: 'dots',
      versionApp: version,
      userAgent: navigator.userAgent,
      userPlatform: navigator.platform,
      languages: [
        { title: 'it', img: './assets/images/settings_it' },
        { title: 'en', img: './assets/images/settings_en' },
        { title: 'fr', img: './assets/images/settings_fr' },
        { title: 'de', img: './assets/images/settings_de' },
        { title: 'es', img: './assets/images/settings_es' }
      ],
      selectedLang: { title: 'it', img: './assets/images/settings_it' },
      topMenuLabel: ''
    }
  },
  computed: {
    ...mapState({
      loadingState: state => state.loading,
      modal: state => state.modal,
      modalText: state => state.modalText
    })
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      this.topMenuLabel = topMenuLink().key
        ? this.$i18n.t(topMenuLink().key)
        : ''
    }
  },
  mounted: async function() {
    window.addEventListener('resize', this.onResize)
    console.log(this.versionApp)
    const currLocale = this.$i18n.locale
    await this.setLocale(currLocale)
    const localFlag = this.languages.find(x => x.title == this.$i18n.locale)
    if (localFlag) await this.selectLang(localFlag)
    const menuLink = topMenuLink()
    this.topMenuLabel = menuLink.key ? this.$i18n.t(menuLink.key) : ''
    // if (
    //   this.$route.query.action.toLowerCase() == 'checkout' &&
    //   this.$route.query.price_id != null &&
    //   (this.$route.name.toLowerCase() == 'home' ||
    //     this.$route.name.toLowerCase() == 'login')
    // )
    //   this.$store.dispatch('openModal', this.$i18n.t('checkoutStripe'))
  },
  methods: {
    dismissModal() {
      this.$store.dispatch('resetModal')
    },
    handleChoiceCookie() {
      window.location.reload()
    },
    updatedLang() {
      const menuLink = topMenuLink()
      this.topMenuLabel = menuLink.key ? this.$i18n.t(menuLink.key) : ''
    },
    handleCookieLawResults() {
      const cookieValue =
        localStorage.getItem('cookie:accepted') == 'true' ? true : false
      if (!cookieValue) {
        this.$ga.disable()
        //firebase
      }
    },
    clickedContactUs() {
      trackEvent(this.$constants.WEB_CONTACTUS)
    },
    clickedWebsite() {
      trackEvent(this.$constants.WEB_GOTO_WEBSITE)
    },
    topMenuClick: async function() {
      const topMenuObj = topMenuLink()
      if (topMenuObj && topMenuObj.link == '/logout') {
        trackEvent(this.$constants.WEB_AUTH_LOGOUT)
        await this.$store.dispatch('logoutUser')
        this.$router.replace('/login')
        window.location.reload()
      } else if (topMenuObj && topMenuObj.key) {
        this.$router.replace({
          path: topMenuObj.link
        })
      }
    },
    selectLang: async function(item) {
      this.selectedLang = item
      await this.setLocale(item.title)
    },
    setLocale: async function(locale) {
      this.$i18n.locale = locale
      await this.$store.dispatch('changeLang', { lang: this.$i18n.locale })
      localeChanged()
      this.updatedLang()
    },
    getImageLangUrl: function(item) {
      if (item && item.img) return require(`${item.img}.png`)
      else return null
    },
    onResize() {
      if (window.innerWidth && window.innerWidth > 768) {
        this.isMobile = false
      } else {
        this.isMobile = true
      }
    }
  }
}
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  flex: 1;
  display: flex;
  flex-direction: column;
}

@import url('https://fonts.googleapis.com/css2?family=Nunito:ital,wght@0,400;0,600;0,700;0,800;1,400;1,600;1,700;1,800&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400;1,500;1,600;1,700;1,800&display=swap');

#app {
  .headerGrid {
    display: grid;
    grid-template-columns: repeat(16, 1fr);
  }
  .v-input__append-inner {
    display: none;
  }

  .v-select__selections {
    display: flex;
    flex-direction: row-reverse;
  }
  .v-menu__content {
    box-shadow: 0px 0px 6px rgba(85, 30, 210, 0.19);
    top: 62px !important;
  }

  .theme--light.v-list-item--active::before {
    opacity: 0;
  }

  .dropLanguage.v-text-field > .v-input__control > .v-input__slot:before {
    border-style: none;
  }
  .dropLanguage.v-text-field > .v-input__control > .v-input__slot:after {
    border-style: none;
  }

  .dropdownImgOptionsContainer {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    width: 4em;
    align-content: center;
    justify-content: center;
  }

  .dropLanguageCodeContainer {
    grid-column: 1/4;
    text-align: center;
    font-size: 0.895em;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .dropLanguageCode {
    color: var(--formColor);
  }
  .dropdownImg {
    grid-column: 4/7;
    align-self: center;
    width: 100% !important;
  }

  .dropdownImgSelected {
    width: 80%;
  }

  .dropdownImgSelectedParent {
    display: flex;
    justify-content: flex-end;
  }

  .dropLanguage {
    grid-column: 15/17;
    z-index: 10;
    margin-right: 10px;
    display: flex;
  }

  .menuText {
    grid-column: 11/15;
    justify-self: flex-end;
    align-self: center;
    text-align: right;
    color: var(--formColor);
    font-size: 0.875em;
    cursor: pointer;
  }
  .versionText {
    font-family: 'Raleway';
    color: black;
    font-size: 10px;
    font-weight: 400;
    margin: 0px !important;
  }
  .footerText {
    color: white;
    font-family: 'Raleway';
    font-size: 14px;
    font-weight: 400;
    margin: 0px !important;
  }
  .footerTextSmall {
    color: white;
    font-family: 'Raleway';
    font-size: 12px;
    font-weight: 400;
    margin: 0px !important;
  }
  .downloadApp {
    margin-top: 5vh;
    min-height: 50px;
    padding-top: 10px;
  }
}

#nav {
  padding: 30px;
}

#home {
  .st {
    background-color: #ffffff;
    padding: 0px 0px 0px 0px;
    z-index: 1;
  }
  .imgCoverJoin {
    background-image: url('./assets/images/home/join_us.jpg');
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;
    height: 225px;
  }

  .storeImage {
    width: 10px;
  }

  .promotion {
    background-color: white;
  }
  .join {
    background-color: #f9f9f9;
  }

  .download {
    background-color: white;
  }

  .promotionHeader {
    color: #6ec1e4;
  }

  .joinHeader {
    color: #fd5f20;
  }

  ul li a {
    color: black;
  }
  a {
    color: black;
  }
  .textNav {
    color: black;
  }
}

.imageTop {
  width: 100px;
  object-fit: cover;
}
.smart_img {
  width: 50%;
  max-width: 50%;
}
.footer-container {
  flex-direction: row;
  align-items: center;
}
.loveText {
  align-items: flex-end;
}
.spinner {
  position: fixed;
  z-index: 999;
  overflow: show;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.appsContainer {
  width: 80%;
}

ul.listStyle a.listStyleEntry,
ul.listStyle a.listStyleEntry:visited,
ul.listStyle a.listStyleEntry:link,
ul.listStyle a.listStyleEntry:hover,
ul.listStyle a.listStyleEntry:active {
  color: #54595f;
  font-family: 'Raleway';
  font-weight: 600;
  font-size: 16px;
}
.listStyle {
  list-style: none;
  text-decoration: none;
}
.listItem {
  margin-bottom: 1.25rem;
}

.footerContainer {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  margin-top: 4em;
}

.footerReserved {
  grid-row: 3;
  color: var(--footerReserved);
  grid-column: 2/12;
  font-size: 0.688em;
  margin-top: 1em;
  align-self: center;
  align-items: center;
}

.versionText {
  grid-row: 4;
  color: var(--formColor);
  grid-column: 2/12;
  font-size: 0.2em;
  align-self: center;
  align-items: center;
}

.footerReservedHeart {
  color: var(--primary);
  display: inline-block;
}

.footerLine {
  width: 100%;
  text-align: center;
  border-bottom: 1px solid var(--line2);
  line-height: 0.1em;
  margin: 10px 0 20px;
  grid-row: 1;
  grid-column: 2/12;
}

.site-nav {
  padding: 5px 0px;
  gap: 10px;
}

.site-nav .logoContainer {
  grid-row: 1;
  grid-column: 1/4;
  padding-left: 5px;
  display: flex;
}

.site-nav .logoContainer .imgSmartTales {
  width: 100%;
  max-width: 150px;
  align-self: center;
  margin: 0px 5px;
}
.site-nav .logoContainer .imgLogo {
  width: 100%;
  max-width: 70px;
  align-self: center;
  margin: 0px;
}

.site-nav span {
  grid-row: 1;
  grid-column: 8/9;
}

.footerLeftBox {
  display: flex;
  grid-row: 2;
  grid-column: 2/6;
  justify-content: center;
}

.footerRightBox {
  display: flex;
  grid-row: 2;
  grid-column: 8/12;
  justify-content: center;
  flex-direction: column;
  font-size: 0.875em;
  color: #47cde6;
}

.footerLeftBox .imgSmartTales {
  width: 100%;
  max-width: 150px;
  align-self: center;
  margin: 0px 5px;
}
.footerLeftBox .imgLogo {
  width: 100%;
  max-width: 150px;
  align-self: center;
  margin: 0px;
}

.headerContainer {
  box-shadow: 0px 0px 6px rgba(85, 30, 210, 0.19);
  background: white;
  top: 0px;
  position: fixed;
  width: 100%;
  z-index: 999;
}

.v-text-field__details {
  display: none !important;
}

.routerContainer {
  margin-top: 80px !important;
}

/* small tables styles */
@media screen and (min-width: 620px) {
  .routerContainer {
    margin-top: 100px !important;
  }
  .routerContainer {
    max-width: 800px;
    margin: auto;
    box-shadow: 0px 0px 6px -1px rgba(85, 30, 210, 0.19);
    clip-path: inset(0px -6px -6px -6px);
  }
  .headerGrid {
    margin: auto;
  }
  .dropdownImgSelected {
    max-width: 70px;
  }
}

/* desktop styles */
@media screen and (min-width: 1200px) {
  .routerContainer {
    margin-top: 68px !important;
  }
  .v-text-field {
    margin: 0px !important;
    padding-top: 0px !important;
  }
  .v-input__slot {
    margin-bottom: 0px;
  }
  .headerGrid {
    margin: auto;
    max-width: 1200px;
  }
  .dropdownImgSelected {
    max-width: 50px;
  }
  .site-nav .logoContainer .imgSmartTales {
    max-width: 150px;
  }
  .site-nav .logoContainer .imgLogo {
    max-width: 150px;
  }
}

.modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 98;
  background-color: rgba(0, 0, 0, 0.3);
}

.modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 99;

  width: 100%;
  max-width: 400px;
  background-color: #fff;
  border-radius: 16px;

  padding: 25px;

  h1 {
    color: #222;
    font-size: 32px;
    font-weight: 900;
    margin-bottom: 15px;
  }

  p {
    color: #666;
    font-size: 18px;
    font-weight: 400;
    margin-bottom: 15px;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.slide-enter-active,
.slide-leave-active {
  transition: transform 0.5s;
}

.slide-enter,
.slide-leave-to {
  transform: translateY(-50%) translateX(100vw);
}
</style>
